<template>
    <div class="viewBox">
        <div class="editor">
            <div class="left">
               <button @click="changePhoto(index)" :class="photoActiveIndex==index ? 'photoActive':''" v-for="(item,index) in photoList" :key="index">
                    <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/blackWhitePhotoColoring/before${item}`" >
               </button>
            </div>
            <div class="right">
                <div class="content" >
                    <div class="after"  :style="afterStyle" ref="afterImg">
                        <p class="title">上色后</p>
                         <img :class="loading" ref="transformImg"   :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/blackWhitePhotoColoring/after${photoList[photoActiveIndex]}`" alt="">
                    </div>
                    <div class="before"  :style="beforeStyle" ref="beforeImg">
                        
                         <img ref="copyformImg"     :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/blackWhitePhotoColoring/before${photoList[photoActiveIndex]}`" alt="">
                    </div>
                    <button @mousedown="changeStart" :style="buttonStyle" ref="filterButton" class="button" >
                        <p class="title">上色前</p>
                        <span v-html="svg"></span>
                    </button>
                </div>
               
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            photoList:[
                '1.jpg',
                '2.jpg',
                '3.jpg',
                '4.jpg',
                '5.jpg',
            ],
            photoActiveIndex:0,
            svg:`<svg width="50" height="50"><g fill-rule="nonzero" fill="none"><path d="M0 25c0 13.807 11.193 25 25 25s25-11.193 25-25S38.807 0 25 0 0 11.193 0 25z" fill="#5986FF"></path><path d="M38.713 25.968a1.387 1.387 0 000-1.948l-7.805-7.874a1.358 1.358 0 00-1.328-.375c-.477.126-.85.502-.975.984s.018.994.372 1.34l6.84 6.9-6.84 6.9c-.361.344-.508.86-.384 1.345.124.486.5.865.981.99.482.126.993-.023 1.334-.388l7.805-7.874zm-19.621-9.822l-7.805 7.874a1.387 1.387 0 000 1.948l7.805 7.874c.341.365.852.514 1.334.389.481-.126.857-.505.981-.99a1.386 1.386 0 00-.384-1.347l-6.84-6.9 6.84-6.9a1.387 1.387 0 00-.028-1.92 1.357 1.357 0 00-1.903-.028z" fill="#FFF"></path></g></svg>`
            ,afterStyle:{
                clipPath: `inset(0px ${936/2}px 0px 0px)`
            },
            beforeStyle:{
                clipPath: `inset(0px 0px 0px ${936/2}px)`
            },
            buttonStyle:{
                left: `${936/2}px`
            },
            loading:'',
            isDown:false
        }
    },
    
    methods:{
        changePhoto(index){
            this.photoActiveIndex = index;
            this.loading = 'filterLoading';
               this.$refs.filterButton.style.left = `${936/2}px`
            this.$refs.afterImg.style.clipPath = `inset(0px ${936/2}px 0px 0px)`
            this.$refs.beforeImg.style.clipPath =`inset(0px 0px 0px ${936/2}px)`
            setTimeout(()=>{
                this.loading = ''
            },1000)
        },
        changeStart(e){
            let odiv = this.$refs.filterButton;        //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft;
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX;    
                //绑定元素位置到positionX和positionY上面
                this.positionX = top;
                //移动当前元素
                odiv.style.left = left + 'px';
                this.$refs.afterImg.style.clipPath = `inset(0px ${936-left}px 0px 0px)`
                this.$refs.beforeImg.style.clipPath = `inset(0px 0px 0px ${left}px)`
                
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        },
       
        
    },
    created() {
       
    },
}
</script>
<style lang="scss" scoped>
    .editor{
        width:1280px;
        margin: auto;
        border-radius: 8px;
        overflow: hidden;
        background-color: #171a27;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: normal;
        justify-content: normal;
        -ms-flex-align: normal;
        align-items: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        margin-bottom: 16px;
        .left{
            width: 244px;
            position: relative;
            padding: 50px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            button{
                width: 102px;
                height: 102px;
                border: none;
                padding: 0;
                overflow: hidden;
                position: relative;
                margin-top: 18px;
                &:first-child{
                    margin-top: 0;
                }
                cursor: pointer;
                img{
                    width: inherit;
                    height: inherit;
                    position: absolute;
                    top: 0;
                    left: 0;
                    -o-object-fit: cover;
                    object-fit: cover;
                    -o-object-position: center;
                    object-position: center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
            }
            .photoActive{
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border: 4px solid transparent;
                    -webkit-transition: border-color ease-in-out 280ms;
                    -o-transition: border-color ease-in-out 280ms;
                    transition: border-color ease-in-out 280ms;
                    border-color: #5986ff;
                }
            }
        }
        .right{
           -ms-flex: 1 1;
            flex: 1 1;
            padding: 50px;
            background-color: #202537;
            position: relative;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: center;
            justify-content: center;
            -ms-flex-align: start;
            align-items: flex-start;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            .content{
                position: relative;
                width: 100%;
                z-index: 1;
                min-height: 100px;
                overflow: hidden;
                margin: 0;
                background-size: 20px 20px;
                background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 2"><path d="M1 2V0h1v1H0v1z" fill-opacity=".025"/></svg>');
                &::before{
                    content: '';
                    display: block;
                    padding-top: 75%;
                }
                .after,.before{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    contain: strict;
                    -ms-touch-action: none;
                    touch-action: none;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -ms-flex-align: center;
                    align-items: center;
                    -ms-flex-direction: row;
                    flex-direction: row;
                    -ms-flex-wrap: nowrap;
                    flex-wrap: nowrap;
                    .title{
                        background: #5986ff;
                        color: #fff;
                        font-size: 14px;
                        line-height: 20px;
                        padding: 12px 29px;
                        margin: 0;
                        position: absolute;
                        top: 0;
                        white-space: nowrap;
                        z-index: 2;
                        left: 0;
                    }
                    img{
                        will-change: auto;
                        -ms-flex-negative: 0;
                        flex-shrink: 0;
                        -webkit-transform-origin: 0 0;
                        -ms-transform-origin: 0 0;
                        transform-origin: 0 0;
                        display: block;
                        overflow: hidden;
                        -ms-touch-action: none;
                        touch-action: none;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        -webkit-user-drag: none;
                      
                        transform: translate(0px, 0px) scale(1);
                    }
                }
                .button{
                    position: absolute;
                    -ms-touch-action: none;
                    touch-action: none;
                    width: 30px;
                    will-change: transform;
                    cursor: ew-resize;
                    height: 100%;
                    padding: 0;
                    z-index: 9999;
                    top: 0;
                    left: 0;
                    border: none;
                    background-color: transparent;
                    -webkit-transform: translateX(-50%);
                    -ms-transform: translateX(-50%);
                    transform: translateX(-50%);
                    &::before{
                        content: '';
                        display: block;
                        height: inherit;
                        width: 4px;
                        margin: 0 auto;
                        background: #5986ff;
                    }
                    span{
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        overflow: hidden;
                        -webkit-transform: translate(-50%, -50%);
                        -ms-transform: translate(-50%, -50%);
                        transform: translate(-50%, -50%);
                    }
                }
                .button .title{
                        left: 50%;
                        background: #5986ff;
                        color: #fff;
                        font-size: 14px;
                        line-height: 20px;
                        padding: 12px 29px;
                        margin: 0;
                        position: absolute;
                        top: 0;
                        white-space: nowrap;
                        z-index: 2;
                       
                }
            }
            img{
                position: relative;
                
                z-index: 1;
                min-height: 100px;
                overflow: hidden;
            }
        }
    }
    .filterLoading{
        filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg"><filter id="filter"><feGaussianBlur stdDeviation="10" /></filter></svg>#filter');
        -webkit-filter: blur(10px);
        filter: blur(10px);
    }
</style>